export enum DoorRailStyle {
  TopRail = 'top-rail',
  TopRailWithCasing = 'top-rail-with-casing',
}
